export * as ellipse1 from './ellipse1.svg'
export * as ellipse2 from './ellipse2.svg'
export * as ellipse3 from './ellipse3.svg'
export * as ellipse4 from './ellipse4.svg'
export * as ellipse5 from './ellipse5.svg'
export * as ellipse6 from './ellipse6.svg'
